import { AGG } from 'crm-pipeline-board-settings-lib/aggregations/types/Aggregations';
import { createQuery } from './amountQuery';
import { createHandleResult } from './amountHandleResult';
import { createReconcile } from './amountReconcile';
import AmountText from './AmountText';
import { getId } from '../../utils/getId';
import AmountTooltipText from './AmountTooltipText';
import { jsx as _jsx } from "react/jsx-runtime";
export const createAmountAggregator = (originalConfig, currencyOptions) => {
  /**
   * We force aggregation to SUM as we perform AVG calc in the AmountText and
   * AmountTooltipText components. Those components also take the originalConfig
   * so they know if it needs to be calculated or not.
   */
  const config = Object.assign({}, originalConfig, {
    aggregation: AGG.SUM
  });
  const query = createQuery(config, currencyOptions);
  const handleResult = createHandleResult(config, currencyOptions);
  const reconcile = createReconcile(config, currencyOptions);
  const getText = (aggregation, footerProps) => /*#__PURE__*/_jsx(AmountText, {
    aggregation: aggregation,
    metadata: footerProps.metadata,
    config: originalConfig,
    totalCards: footerProps.totalCards,
    stageId: footerProps.id,
    currencyOptions: currencyOptions
  });
  const getTooltipText = (aggregation, footerProps) => /*#__PURE__*/_jsx(AmountTooltipText, {
    aggregation: aggregation,
    metadata: footerProps.metadata,
    totalCards: footerProps.totalCards,
    config: originalConfig,
    stageId: footerProps.id
  });
  return {
    id: getId(config),
    query,
    handleResult,
    reconcile,
    getText,
    getTooltipText
  };
};